import React from 'react';

interface ErrorScreenProps {
  error: string;
  onRetry: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ error, onRetry }) => {
  return (
    <div className="error-screen">
      <div className="error-content">
        <div className="error-icon">❌</div>
        <h2>Что-то пошло не так</h2>
        <p className="error-message">{error}</p>
        <button className="retry-button" onClick={onRetry}>
          🔄 Попробовать снова
        </button>
      </div>
    </div>
  );
};
